// pages/Unauthorized.tsx
import React from 'react';
import { Link } from 'react-router-dom';

export const Unauthorized: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen  bg-bg text-text">
      <h1 className="text-9xl font-extrabold text-danger tracking-widest">403</h1>
      <div className=" text px-2 text-sm rounded rotate-12 absolute">
        Yetkisiz Erişim
      </div>
      <p className="mt-8 text-lg text ">Bu sayfayı görüntüleme yetkiniz yok.</p>
      <button className="mt-5 btn-primary">
        <Link
          to="/"
          className="relative inline-block text-sm font-medium text-danger group active:text-danger focus:outline-none focus:ring"
        >
          <span className="absolute inset-0 transition-transform translate-x-0.5 translate-y-0.5   group-hover:translate-y-0 group-hover:translate-x-0"></span>
          <span className="relative block px-8 py-3  border border-current">
            Ana Sayfaya Dön
          </span>
        </Link>
      </button>
    </div>
  );
};